import { Component, input, output, computed } from '@angular/core';


@Component({
  standalone: true,
  imports: [],
  selector: 'lib-switchboard-button',
  template: `
    <button
      (click)="handleClick()"
      type="button"
      [disabled]="disabled()"
      [class]="buttonClasses()"
      [title]="title()"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke-width="1.5"
        stroke="currentColor"
        [class]="iconClasses()"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M3.75 6A2.25 2.25 0 0 1 6 3.75h2.25A2.25 2.25 0 0 1 10.5 6v2.25a2.25 2.25 0 0 1-2.25 2.25H6a2.25 2.25 0 0 1-2.25-2.25V6ZM3.75 15.75A2.25 2.25 0 0 1 6 13.5h2.25a2.25 2.25 0 0 1 2.25 2.25V18a2.25 2.25 0 0 1-2.25 2.25H6A2.25 2.25 0 0 1 3.75 18v-2.25ZM13.5 6a2.25 2.25 0 0 1 2.25-2.25H18A2.25 2.25 0 0 1 20.25 6v2.25A2.25 2.25 0 0 1 18 10.5h-2.25a2.25 2.25 0 0 1-2.25-2.25V6ZM13.5 15.75a2.25 2.25 0 0 1 2.25-2.25H18a2.25 2.25 0 0 1 2.25 2.25V18A2.25 2.25 0 0 1 18 20.25h-2.25A2.25 2.25 0 0 1 13.5 18v-2.25Z"
        />
      </svg>
    </button>
  `,
})
export class SwitchboardButtonComponent {
  // Input signals
  disabled = input<boolean>(false);
  title = input<string>('Go to Switchboard');
  size = input<'sm' | 'md' | 'lg'>('md');
  variant = input<'default' | 'dark'>('default');

  // Output signals
  buttonClick = output<void>();

  // Computed classes based on size and variant
  buttonClasses = computed(() => {
    const baseClasses =
      'inline-flex items-center justify-center rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 transition-colors duration-200';

    const variantClasses = this.getVariantClasses();
    const sizeClasses = this.getSizeClasses();

    return `${baseClasses} ${variantClasses} ${sizeClasses}`;
  });

  iconClasses = computed(() => {
    const sizeIconClasses = this.getIconSizeClasses();
    return `flex-shrink-0 ${sizeIconClasses}`;
  });

  private getVariantClasses(): string {
    if (this.variant() === 'dark') {
      return 'text-gray-300 hover:text-orange-400 hover:bg-gray-800 focus:ring-offset-gray-900';
    }
    return 'text-gray-600 hover:text-orange-500 hover:bg-gray-100 focus:ring-offset-white';
  }

  private getSizeClasses(): string {
    switch (this.size()) {
      case 'sm':
        return 'p-1.5';
      case 'lg':
        return 'p-3';
      default:
        return 'p-2';
    }
  }

  private getIconSizeClasses(): string {
    switch (this.size()) {
      case 'sm':
        return 'w-4 h-4';
      case 'lg':
        return 'w-8 h-8';
      default:
        return 'w-6 h-6';
    }
  }

  handleClick(): void {
    if (!this.disabled()) {
      this.buttonClick.emit();
    }
  }
}
